import { render, staticRenderFns } from "./PropertyHistory.vue?vue&type=template&id=1c9bdb92&"
import script from "./PropertyHistory.vue?vue&type=script&lang=ts&"
export * from "./PropertyHistory.vue?vue&type=script&lang=ts&"
import style0 from "./PropertyHistory.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports